import { useCallback, useState, useMemo } from 'react';
import { useActions, useAppSelector, MailActions } from '@web-common/state/createStore';
import { createSelector } from '@reduxjs/toolkit';
import { isMailDiff } from '@web-mail/utils/mailCompare';
const useMailStoreState = (initMailList, noMerge) => {
    var _a;
    const [selectMailIds, setSelectMailIds] = useState(Array.isArray(initMailList) ? initMailList === null || initMailList === void 0 ? void 0 : initMailList.map(mail => { var _a; return (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id; }) : ((_a = initMailList === null || initMailList === void 0 ? void 0 : initMailList.entry) === null || _a === void 0 ? void 0 : _a.id) || '');
    const mailStore = useCallback((state) => state.mailReducer.mailEntities, []);
    const updateMailStroeReducer = noMerge ? useActions(MailActions).updateMailEntitiesNoMerge : useActions(MailActions).updateMailEntities;
    const mailSelecter = useMemo(() => createSelector([mailStore], store => {
        if (Array.isArray(selectMailIds)) {
            return selectMailIds ? selectMailIds.map(id => store[id]) : [];
        }
        else {
            return store[selectMailIds];
        }
    }), [selectMailIds]);
    const selectMailList = useAppSelector(mailSelecter, (prev, next) => !isMailDiff(prev, next, undefined, true));
    const setter = useCallback(mailList => {
        var _a;
        let list;
        if (typeof mailList === 'function') {
            list = mailList(selectMailList);
        }
        else {
            list = mailList;
        }
        if (Array.isArray(list)) {
            if (list) {
                updateMailStroeReducer({
                    mailList: list,
                });
                setSelectMailIds(list.map(item => item.entry.id));
            }
        }
        else {
            if (list) {
                list = list;
                updateMailStroeReducer({
                    mailList: [list],
                });
            }
            setSelectMailIds((_a = list === null || list === void 0 ? void 0 : list.entry) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [setSelectMailIds]);
    return [selectMailIds ? selectMailList : null, setter];
};
export default useMailStoreState;
